module.exports = __webpack_public_path__ + "img/img_owned_patent07.bfe33bf6.jpg";